export default {
	baseUrl: "/api"
};
